export default __webpack_public_path__ + "themes/_global/img/icons/Diaspora-asterisk.svg";